import { computed, ComputedRef } from 'vue'

import {
  IncidentFilter,
  IncidentFilterSelect,
  IncidentFilterToggle,
} from '../../types'
import { getIncidentFiltersSelect, getIncidentFiltersToggle } from '../../utils'

export function useActiveIncidentFilters(
  incidentFiltersToggle: ComputedRef<IncidentFilterToggle[]>,
  incidentFiltersSelect: IncidentFilterSelect[],
): {
  activeIncidentFilters: ComputedRef<IncidentFilter[]>
} {
  // computed
  const activeIncidentFilters = computed(() => [
    ...getIncidentFiltersToggle(incidentFiltersToggle.value),
    ...getIncidentFiltersSelect(incidentFiltersSelect),
  ])

  return {
    activeIncidentFilters,
  }
}
